/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.DeleteUserResponse,
  deleteUser: (params: vp.DeleteUserRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const userPostDeleteUser: ApiHook = ({ api }) => {
  const [shouldDeleteUser, setShouldDeleteUser] = useState(false);
  const source = axios.CancelToken.source();
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  const [params, setParams] = useState<vp.DeleteUserRequest>({
    EmailAddress: '',
  });
  const [response, setResponse] = useState<vp.DeleteUserResponse>({
    Success: false,
    ErrorMessage: '',
    UserID: '',
    IsActive: false,
  });

  useEffect(() => {
    if (!shouldDeleteUser) return () => {};

    const DeleteUser = async () => {
      setDataFetchingInfo(true, 'deleting user', 'fullScreen');
      const res = await api.postDeleteUser(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldDeleteUser) void DeleteUser();
    setShouldDeleteUser(false);
    return () => {
      source.cancel();
    };
  }, [shouldDeleteUser]);

  return [
    response,
    (_params: vp.DeleteUserRequest) => {
      setParams(_params);
      setShouldDeleteUser(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        UserID: '',
        IsActive: false,
      });
      setShouldDeleteUser(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(userPostDeleteUser);
